<div
  class="img-wrap h-100"
  data-test="stream-thumb"
  *ngIf="props$ | async as props"
>
  <div class="overlay" data-test="stream-overlay" *ngIf="props.canRemove"></div>
  <img
    *ngIf="props.image && (thumbnailError$ | async) === null"
    [src]="props.image"
    (error)="updateThumbnailError($event)"
    class="thumbnail-img rounded-top no-skeleton"
    data-test="stream-image"
  />
  <span
    class="playing color-100"
    *ngIf="props.isPlaying"
    data-test="stream-playing-svg"
  ><flo-svg-icon icon="streaming-bars" width="1em"></flo-svg-icon></span>
  <span
    data-test="add-svg"
    class="position-absolute center-x center-y color-100 plus-outline svg-vertical-align-top"
    *ngIf="props.canAdd"
  ><flo-svg-icon class="position-absolute plus-outline-svg" icon="plus-outline" width="40px"></flo-svg-icon></span>
  <span
    data-test="remove-svg"
    class="position-absolute center-x center-y color-100 svg-vertical-align-top"
    *ngIf="props.canRemove"
  ><flo-svg-icon icon="minus-outline" width="40px"></flo-svg-icon></span>
  <h3
    *ngIf="!props.isPlaying && showNameBadge"
    data-test="stream-name-badge"
    class="stream-name font-primary bg-grey-700 position-absolute bottom left m-1 py-1 px-2 text-truncate"
  >
    {{ props.name }}
  </h3>
</div>
